import React, { useRef } from 'react';
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';

export default function Tooltip({ content, children, allowCopy }) {
  const toCopy = useRef(null);

  const renderTooltip = props => (
    <BootstrapTooltip {...props}>
      <div ref={toCopy} className="text-secondary font-weight-bold">
        {content || children}
      </div>
    </BootstrapTooltip>
  );

  return (
    <OverlayTrigger placement="right" overlay={renderTooltip} trigger={['hover', 'focus']} rootClose>
      <span className="cursor-pointer">{children}</span>
    </OverlayTrigger>
  );
}
